import React, { useState, useEffect } from "react";
import { API_URL, createMarkup } from "../helpers";
import Hdg from "../components/Hdg";
import Nav from "../components/Nav";
import Alert from "../components/Alert";
//import Select from "../components/Select";

const Participating = () => {
	const [names, setNames] = useState({});
	const [html, setHtml] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		init("", false);
	}, []);

	const init = async (crit, sorted) => {
		const url = new URL(`${API_URL}/participatingInit`);
		const params = {
			crit,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNames({ data: json.data });
				if (!sorted) {
					setHtml({
						left: json.left,
						right: json.right,
					});
					setAlert({});
					window.jQuery(".cycle-slideshow").cycle("stop");
					window.jQuery(".cycle-slideshow").cycle();
				}
			} else {
				setAlert({
					type: json.resp === 2 ? "notice" : "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "crit") {
			setNames({ data: [] });
			init(value, true);
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg />
						<Nav />

						<div dangerouslySetInnerHTML={createMarkup(html.left)} />

						<div className="form-group">
							<div>
								<label className="control-label">
									<span>Sort Charities by Region or Charitable Mission</span>
								</label>
								<select
									className="form-control"
									id="crit"
									name="crit"
									onChange={(e) => handleUpdate("crit", e.target.value)}
								>
									<option value="">--</option>
									<optgroup label="Regions">
										{[
											"San Antonio & Texas Hill Country",
											"Central Texas - Austin, Waco, Temple, Bryan/College Station",
											"Coastal Bend - Corpus Christi, Victoria, Kingsville, Three Rivers",
											"East Texas - Tyler, Longview, Texarkana, Lufkin",
											"North Texas - Dallas/Fort Worth, Denton, Wichita Falls",
											"South Texas & Rio Grande Valley - Laredo, Brownsville, McAllen",
											"Southeast Texas - Houston, Beaumont, Port Arthur",
											"West Texas - Amarillo, Lubbock, Midland, El Paso",
											"Other U.S. States",
											"International",
										].map((item, index) => {
											return (
												<option value={item} key={index}>
													{item}
												</option>
											);
										})}
									</optgroup>
									<optgroup label="Charitable Missions">
										{[
											"Animals",
											"Arts & Culture",
											"Basic Needs",
											"Civic & Community Advocacy",
											"Disability Services",
											"Economic Development",
											"Education",
											"Emergency & Disaster Relief",
											"Employment & Entrepreneurship",
											"Environment",
											"Families",
											"Food Insecurity",
											"Health Care & Wellness",
											"Housing & Shelter",
											"International & Foreign Affairs",
											"LGBQT+",
											"Military & Veterans",
											"Racial Equity & Social Justice Advocacy",
											"Religion",
											"Science & Technology",
											"Senior Citizen Services",
											"Sports",
											"Substance Abuse Prevention",
											"Youth Development",
										].map((item, index) => {
											return (
												<option value={item} key={index + 100}>
													{item}
												</option>
											);
										})}
									</optgroup>
								</select>
							</div>
						</div>

						<ul className="columns-two" id="charities">
							{names.data.map((item, index) => {
								return item.link ? (
									<li key={index}>
										<a href={item.link}>{item.name}</a>
									</li>
								) : (
									<li key={index}>{item.name}</li>
								);
							})}
						</ul>

						<div className="spacer"></div>
					</div>
					<div
						id="right-column"
						dangerouslySetInnerHTML={createMarkup(html.right)}
					/>
				</>
			)}
		</>
	);
};

export default Participating;
